import request from '@/request'
export const publicUpload = (data) => {
    return request({
        url:`/api-gateway/service/publicUpload`,
        method:'post',
        headers:{
            'Content-Type':'multipart/form-data'
        },
        data,
    });
};
export const publicDeleteFile = (data) => {
    return request({
        url:`/api-gateway/service/publicDeleteFile`,
        method:'post',
        data,
    });
};
export const queryShareFile = (id,data) => {
    return request({
        url:`/api-gateway/service/queryShareFile/${id}`,
        method:'post',
        data,
    });
}
export const uniqueName = (data) => {
    return request({
        url:'/api-gateway/service/uniqueNameNetDiskFile',
        method:'post',
        data,
    });
}
export const saveNetDiskFile = (data) => {
    return request({
        url:'/api-gateway/service/publicSaveFolder',
        method:'post',
        data,
    });
}